import { Autocomplete, TextField } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete';
import type { Optional } from '@vy/utils';
import { isNotNullOrUndefined, isNullOrUndefined, validateEnum, values } from '@vy/utils';
import { raiseUnreachable } from '@vy/utils';

const INTERVALS = {
  MONTHLY: 1,
  BI_MONTHLY: 2,
  QUARTERLY: 3,
  EVERY_SIX_MONTHS: 6,
  YEARLY: 12,
} as const;

type AccumulationIntervalSelectProps = Omit<
  AutocompleteProps<number, false, true, false>,
  'options' | 'renderInput'
> & {
  label?: string;
  maximumInterval?: number;
};

export const AccumulationIntervalSelect: React.FC<AccumulationIntervalSelectProps> = (props) => {
  const { maximumInterval, label, ...restOfProps } = props;

  return (
    <Autocomplete
      fullWidth
      autoHighlight
      size="medium"
      getOptionLabel={getAccumulationIntervalLabel}
      disableClearable
      {...restOfProps}
      options={values(INTERVALS)}
      getOptionDisabled={(option) => isNotNullOrUndefined(maximumInterval) && option > maximumInterval}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            }
          }}
        />
      )}
    />
  );
};

export function getAccumulationIntervalLabel(accumulationInterval: Optional<number>) {
  if (isNullOrUndefined(accumulationInterval) || accumulationInterval === 0) {
    return '';
  }

  validateEnum(accumulationInterval, INTERVALS);

  switch (accumulationInterval) {
    case INTERVALS.MONTHLY:
      return 'Monthly';
    case INTERVALS.BI_MONTHLY:
      return 'Bi monthly';
    case INTERVALS.QUARTERLY:
      return 'Quarterly';
    case INTERVALS.EVERY_SIX_MONTHS:
      return 'Every 6 months';
    case INTERVALS.YEARLY:
      return 'Yearly';
    default:
      return raiseUnreachable(accumulationInterval);
  }
}
